import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../public/images/bg_ze.webm'
import _imports_1 from '../../../public/images/bg_ze.mp4'


const _hoisted_1 = { class: "advantanges_cont" }
const _hoisted_2 = { class: "advantages-company__container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("video", {
  playsinline: "",
  autoplay: "",
  muted: "",
  loop: "",
  class: "background-video"
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_0,
    type: "video/webm"
  }),
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_1,
    type: "video/mp4"
  })
], -1)
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "company_in_count" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Zetreex", -1)
const _hoisted_7 = { class: "track__line" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "advantanges__element_line" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "advantanges__cont_stac"
}
const _hoisted_10 = { class: "advantanges__sum" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = {
  key: 1,
  class: "advantanges__sum"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createTextVNode(_toDisplayString(_ctx.getStaticLanguage.inCount), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getStaticLanguage.dataItems, (advantanges, ind) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "advantanges__element",
              key: ind
            }, [
              _hoisted_8,
              _createElementVNode("p", {
                class: _normalizeClass('advantanges_like_' + Number(ind + 1))
              }, [
                _createTextVNode(_toDisplayString(advantanges.text) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(advantanges.span), 1)
              ], 2),
              (ind === 2 || ind === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("h2", _hoisted_10, _toDisplayString(advantanges.sum), 1),
                    _createElementVNode("img", {
                      src: 
                  ind === 1
                    ? require('../../../public/images/User.svg')
                    : require('../../../public/images/Fire.svg')
                ,
                      alt: ind === 1 ? 'User' : 'Fire',
                      class: _normalizeClass(ind === 1 ? 'user' : 'fire')
                    }, null, 10, _hoisted_11)
                  ]))
                : (_openBlock(), _createElementBlock("h2", _hoisted_12, _toDisplayString(advantanges.sum), 1))
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}